<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.qr" @click="handleCreate">调出确认</el-button>
        <!-- <el-button size="small" type="primary" disabled="true" class="btn">导出列表</el-button> -->
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item :label="lable.drdw">
              <el-cascader
              v-model="deviceInfo.transferIn"
              style="width: 140px"
              :options="options"
              :props="companyProps"
              clearable
              :show-all-levels="false"
              filterable
              :placeholder="'请选择' + lable.drdw"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.dcdw">
              <el-cascader
              v-model="deviceInfo.transferOut"
              style="width: 140px"
              :options="options"
              :props="companyProps"
              clearable
              :show-all-levels="false"
              filterable
              :placeholder="'请选择' + lable.drdw"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="allocationData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170" show-overflow-tooltip>
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="sqrq" :formatter="formateTime" :label="lable.sqrq" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="drdw" :label="lable.drdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="dcdw" :label="lable.dcdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userName" :label="lable.userName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="dbly" :label="lable.dbly" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '7'" style="color:gray">待调出确认</span>
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="allocationData.length > 0" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------调出确认弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" title="调出确认" :close-on-click-modal="false" :close-on-press-escape="false"
      style="width:100% !important;margin-left: 80px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw" style="width:90%">
              <el-input v-model="questionForm.dcdw" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-input v-model="questionForm.drdw" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">

            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.statue" prop="">
              <el-input :readonly="true" v-model="questionForm.wz" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="questionForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input :readonly="true" type="textarea" :rows="2" v-model="questionForm.dbly" />
        </el-form-item>
        <el-form-item label="资产列表">
          <el-table :data="assetsData" :border="true" style="width: 100%;text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button type="text" @click="innerVisible = true" icon="el-icon-plus">增加</el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)">删除</el-button>
                <el-button type="text" @click="yulan(scope.row)" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>

              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="confirm" v-preventReClick>确定</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <el-dialog width="30%" title="添加资料" :visible.sync="innerVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" append-to-body>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
              :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
              <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>

    <!--------------------------------------------------------------------调拨详情弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" title="调拨详情" :close-on-click-modal="false"
      :close-on-press-escape="false" style="width:100% !important;margin-left: 100px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw" style="width:90%">
              <el-input v-model="questionForm.dcdw" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-input v-model="questionForm.drdw" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.statue">
              <el-input :readonly="true" v-model="questionForm.wz" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="questionForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.dbly" />
        </el-form-item>
        <el-form-item label="资产列表" prop="correctAnswer">
          <el-table :data="assetsData" :border="true" style="width: 100%;text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>

              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="dialogFormVisible1 = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script>
import {
  findByModule,
  findOutAllocation,
  findByIdFile,
  upload,
  findByIdAllocation,
  findByIdDevice,
  findTransferIn,
  confirmAllocation,
  delByIdFile,
  findByUserIdCompanyTree
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Confirm",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      show: {
        qr: false
      },
      deviceInfo: {
        date: [],
        content: "",
        state: "",
        transferIn: "",
        transferOut: ""
      },
      lable: {},
      
      companyProps: {
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
        checkStrictly: true,
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      transfersData: [],
      allocationData: [],
      assetsData: [],
      multipleTable: [],
      options: [],
      questionForm: {
        transferId: [],
        deviceId: [],
        dblx: ""
      },
      innerVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      form: {
        name: "",
        fileDesc: ""
      },
      fileData: [],
      fileList: [],
      questionForm1: {},
      tableData: [],
      docxdialog: false,
      previewTitle: '',
    };
  },
  methods: {
    
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.sqrq)
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      let date = nowData.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
    },
    onClick(row) {
      if (this.show.qr) {
        this.findByIdfile(row.id);
        this.findByDevice(row.id);
        this.questionForm = row;
        this.dialogFormVisible = true;
      } else {
        this.selectClick(row);
      }
    },
    selectClick(row) {
      this.dialogFormVisible1 = true;
      this.questionForm = row;
      this.findByIdfile(row.id);
      this.findByDevice(row.id);
    },
    handleClick(row) {
    },

    confirm() {
      var a1 = [];
      for (let i = 0; i < this.fileData.length; i++) {
        var a = this.fileData[i];
        a1.push(a.id);
      }
      this.questionForm.fileIds = a1;
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      confirmAllocation(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.findAll();
          this.dialogFormVisible = false;
          this.$message({
            message: "确认成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },

    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        this.findByIdfile(currentSelect[0].id);
        this.findByDevice(currentSelect[0].id);
        this.questionForm = currentSelect[0];
        this.dialogFormVisible = true;
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },

    //根据单号查询调拨设备
    findByDevice(row) {
      findByIdDevice(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.assetsData = data;
        }
      });
    },
    //调拨详情
    findById(row) {
      findByIdAllocation(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.questionForm = data;
        }
      });
    },
    //删除检定附件信息
    DFile(row) {
      // this.fileData.splice(this.fileData.indexOf(row), 1);
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delByIdFile(row.id).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.findByIdfile(this.questionForm.id);
            this.$message({
              message: message,
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },

    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
          // debugger 
        }
      });
    },
    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },
    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        var formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("name", this.form.name);
        formData.append("fileDesc", this.form.fileDesc);
        formData.append("number", this.questionForm.id);
        var userinfo = JSON.parse(localStorage.getItem("user"))

        formData.append("userId", userinfo.userId)
        upload(formData).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            var id = this.questionForm.id;
            this.findByIdfile(id);
            this.$message({
              message: "上传成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
          this.form.fileDesc = "";
          this.form.name = "";
          this.fileList = [];
          this.innerVisible = false;
        });
      }
    },

    //根据id查找申请调入设备信息
    findTransfer(id) {
      findTransferIn(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.transfersData = data;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      if (userinfo.companyCode == "G065") {
        companyCode = "-1";
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
    findAllClick() {
      this.pageIndex = 1
      this.findAll()
    },
    //查找所有调拨信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem('user'))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: 7,
        dblx: 1,
        transferIn: this.deviceInfo.transferIn,
        transferOut: this.deviceInfo.transferOut,
        userId: userinfo.userId
      };
      findOutAllocation(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.allocationData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("调拨管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.findAll();
    this.getCompanyTree();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "85") {
        this.show.qr = true;
      }
    })
  }
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/allocation/Confirm.vue